<template>
  <div class="row">
    <div class="col-8">
      Percent: {{overtime.percent}}
    </div>
    <div class="col-4">
      Hours: {{overtime.hours}}
    </div>
  </div>
</template>

<script>
export default {
  props: ["overtime"]
};
</script>